import React, { useState, useEffect } from 'react';
import { useAuth, API_URL, Currency, DateBR } from '../contexts/AuthContext';
import { Plus, ShoppingBag, Search } from 'lucide-react';

export default function Despesas() {
  const { token } = useAuth();
  const [expenses, setExpenses] = useState<any[]>([]);
  const [summary, setSummary] = useState<any[]>([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ category: '', description: '', amount: '', due_date: '', payment_method: 'money', cash_session_id: '', status: 'open' });
  const [session, setSession] = useState<any>(null);
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (!token) return;
    fetch(`${API_URL}/expenses`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setExpenses(d)).catch(() => {});
    fetch(`${API_URL}/expenses/summary`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setSummary(d)).catch(() => {});
    fetch(`${API_URL}/cash/session/current`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.ok ? r.json() : null).then(s => setSession(s)).catch(() => {});
  }, [token]);

  const save = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const r = await fetch(`${API_URL}/expenses/`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify({ ...form, amount: parseFloat(form.amount) || 0 }) });
      if (!r.ok) { setMsg('Erro ao salvar'); return; }
      setMsg('Despesa registrada'), setOpen(false);
      fetch(`${API_URL}/expenses`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setExpenses(d)).catch(() => {});
      fetch(`${API_URL}/expenses/summary`, { headers: { Authorization: `Bearer ${token}` } }).then(r => r.json()).then(d => setSummary(d)).catch(() => {});
    } catch { setMsg('Erro interno'); }
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Despesas</h1>
          <p className="text-gray-600">Registro e relatório de despesas do comércio</p>
        </div>
        <button onClick={() => setOpen(true)} className="btn-primary"><Plus size={18} /> Nova despesa</button>
      </div>
      {msg && <div className="rounded-lg p-3 text-sm bg-green-50 border border-green-200 text-green-700">{msg}</div>}
      {!session && <div className="rounded-lg p-3 text-sm bg-amber-50 border border-amber-200 text-amber-700">Abra o caixa para registrar despesas pagas.</div>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="card">
          <h2 className="text-sm font-semibold text-gray-700 mb-3">Despesas por categoria</h2>
          <div className="space-y-2">
            {summary.map(s => (
              <div key={s.category} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0 text-sm">
                <span>{s.category}</span>
                <div className="text-right"><div className="font-bold">{Currency(s.total)}</div><div className="text-xs text-gray-500">{s.qtd} lançamento(s)</div></div>
              </div>
            ))}
            {summary.length === 0 && <p className="text-xs text-gray-500 text-center py-4">Sem despesas</p>}
          </div>
        </div>
        <div className="card">
          <h2 className="text-sm font-semibold text-gray-700 mb-3">Últimas despesas</h2>
          <div className="space-y-2">
            {expenses.slice(0, 10).map(e => (
              <div key={e.id} className="flex items-center justify-between py-2 border-b border-gray-100 last:border-0 text-sm">
                <div className="flex items-center gap-2">
                  <span className="badge badge-warn">{e.category}</span>
                  <span className="text-gray-600">{e.description}</span>
                </div>
                <div className="text-right font-medium">-{Currency(e.amount)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {open && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-lg font-bold text-gray-900 mb-4">Nova despesa</h2>
            <form onSubmit={save} className="space-y-3">
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Categoria</label><select className="input" value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}>
                <option value="Aluguel">Aluguel</option><option value="Energia">Energia</option><option value="Água">Água</option><option value="Internet">Internet</option><option value="Frete">Frete</option><option value="Salários">Salários</option><option value="Manutenção">Manutenção</option><option value="Taxas de cartão">Taxas de cartão</option><option value="Impostos">Impostos</option><option value="Outras despesas">Outras despesas</option>
              </select></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Descrição</label><input className="input" value={form.description} onChange={e => setForm({ ...form, description: e.target.value })} required /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Valor (R$)</label><input className="input" type="number" step="0.01" value={form.amount} onChange={e => setForm({ ...form, amount: e.target.value })} required /></div>
              <div><label className="text-xs font-medium text-gray-500 block mb-1">Forma de pagamento</label><select className="input" value={form.payment_method} onChange={e => setForm({ ...form, payment_method: e.target.value })}><option value="money">Dinheiro</option><option value="pix">Pix</option><option value="card">Cartão</option></select></div>
              <div className="flex justify-end gap-2 pt-4">
                <button type="button" onClick={() => setOpen(false)} className="btn-ghost px-4">Cancelar</button>
                <button className="btn-primary">Registrar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
